import React, { PureComponent } from 'react'
import { setPostToTopic, setTopicList } from '@app-core/posts/actions'
import FavoriteButton from './FavoriteButton'
import { connect, compose, withBeacon, withTranslation } from '@hocs'
import Immutable from 'immutable'
import LoginAlert from '@components/Login/LoginAlert'
import { trackingShareProperty } from '@app-core/beacon/beacon'
import appUrl, { openPost } from '@libs/appUrl'
import GaEventFactory from '@components/OptionMenu/GaEventFactory'
import TopicListSelector from './TopicListSelector'
import { ClientError } from '@libs/errorCode'
import { checkIsGuest } from '@libs/auth-utils'

export const LOGIN_ALERT = 'LOGIN_ALERT'
export const LOGIN_PAGE = 'LOGIN_PAGE'

class FavoriteButtonContainer extends PureComponent {
  static defaultProps = {
    topicList: Immutable.fromJS([]),
    showLoginAlertOrDirectOpenLoginPage: LOGIN_ALERT,
  }

  state = {
    isOpenLoginAlert: false,
  }

  componentDidMount() {
    const { defaultTopicList, setTopicList, postId } = this.props
    if (defaultTopicList && defaultTopicList.size > 0) {
      setTopicList({ topicList: defaultTopicList.toJS(), postId })
    }
  }

  render() {
    const {
      savedNum,
      topicList,
      isAddToDefault,
      t,
      favoriteIcon,
      favoritedIcon,
      favoriteText,
      favoritedText,
      children,
    } = this.props
    const isSaved = topicList.filter((item) => !item.get('d')).size > 0
    const content = children ? (
      React.cloneElement(children, { onClick: this._onClickFavorite, toggled: isSaved })
    ) : (
      <FavoriteButton
        setToDefaultTopic={this._setToDefaultTopic}
        setPostToTopic={this._setPostToTopic}
        isAddToDefault={isAddToDefault}
        savedNum={savedNum}
        topicList={topicList.toJS()}
        isSaved={isSaved}
        icon={!isSaved ? favoriteIcon : favoritedIcon}
        text={!isSaved ? favoriteText : favoritedText}
        t={t}
        onClickFavorite={this._onClickFavorite}
      />
    )
    return (
      <>
        {content}
        <LoginAlert isOpen={this.state.isOpenLoginAlert} onClose={this._onCloseLoginAlert} />
      </>
    )
  }

  _sendSavePostEventForATopic = (item) => {
    const { postId, postItem, via, otherEventProperty } = this.props
    const isSaveAction = !!(item.d === 0)

    // send GA event
    const gaEvent = isSaveAction
      ? GaEventFactory.createSavePostEvent(postId)
      : GaEventFactory.createUnsavePostEvent(postId)
    this.props.gtmEventTrack('share', gaEvent)

    // send amplitude event
    const isDefaultTopic = item.privacy === 2 ? 'yes' : 'no'
    const topicPrivacy = item.privacy === 1 ? 'private' : 'public'
    const amplitudeEventName = isSaveAction ? 'save' : 'unsave'
    const tmpEventProperty = {
      via,
      ...otherEventProperty,
      'default.topic': isDefaultTopic,
      'topic.privacy': topicPrivacy,
    }
    const properties = trackingShareProperty(postItem, tmpEventProperty)
    this.props.amplitudeEventTrack(amplitudeEventName, properties)
  }

  _sendSavePostEvent = (newTopicList) => {
    const { topicList } = this.props
    const resultTopic = TopicListSelector.getSavedStateChangedTopic(newTopicList, topicList.toJS())
    if (resultTopic) {
      this._sendSavePostEventForATopic(resultTopic)
    }
  }

  _setPostToTopic = ({ topicList: newTopicList }) => {
    const { postId, setPostToTopic, onChange, topicList } = this.props

    const isLoggedIn = this._checkIfLogin()
    if (isLoggedIn === false) return

    this._sendSavePostEvent(newTopicList)

    // save post to topic API
    const topics = newTopicList.map((item) => {
      return {
        topicID2: item.postID,
        d: item.d,
      }
    })
    setPostToTopic({ postId, topics })

    const originDMap = new Map(topicList.toJS().map((topic) => [topic.postID, topic.d]))
    onChange?.(newTopicList.filter((newTopic) => originDMap.get(newTopic.postID) !== newTopic.d))
  }

  _checkIfLogin = () => {
    if (this.props.isGuest) {
      if (this.props.showLoginAlertOrDirectOpenLoginPage === LOGIN_ALERT) {
        this.setState({ isOpenLoginAlert: true })
      } else if (this.propsshowLoginAlertOrDirectOpenLoginPage === LOGIN_PAGE) {
        openPost(`${appUrl.appUrl}/login`)
      }
      return false
    }
    return true
  }

  _setToDefaultTopic = () => {
    const { topicList, setPostToTopic, postId } = this.props

    const isLoggedIn = this._checkIfLogin()
    if (isLoggedIn === false) return
    const topic = topicList.get(0) || Immutable.fromJS({})
    const d = topic.get('d') ? 0 : 1
    const topics = [
      {
        topicID2: topic.get('postID'),
        d,
      },
    ]
    setPostToTopic({ postId, topics })
    this._sendSavePostEventForATopic(topic.toJS())
  }

  _onCloseLoginAlert = (e) => {
    if (e) {
      e.stopPropagation()
    }
    this.setState({ isOpenLoginAlert: false })
  }

  _onClickFavorite = async () => {
    const { isAddToDefault } = this.props
    const isLoggedIn = this._checkIfLogin()
    if (isLoggedIn === false) {
      throw new ClientError('not logged in', true)
    }
    if (isAddToDefault) {
      this._setToDefaultTopic()
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isGuest: checkIsGuest(state.currentUser.getIn(['userInfo', 'type'])),
    topicList: state.posts.getIn(['topicList', 'data', ownProps.postId]),
  }
}
export { FavoriteButtonContainer }
export default compose(
  withBeacon,
  withTranslation(['common']),
  connect(mapStateToProps, {
    setPostToTopic,
    setTopicList,
  }),
)(FavoriteButtonContainer)
